/*eslint-disable react/no-set-state*/
import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import * as pathConstants from '../../constants/pathConstants';
import CaseDataFileUploadForm from './CaseDataFileUploadForm';
import * as FormName from '../../constants/formNameConstants';
import {searchForFormById} from '../../selectors/searchForForm';
import * as FileUploadConstants from '../../constants/fileUploadConstants';
import * as caseDataFileUploadActions from '../../actions/caseDataFileUploadActions';
import { cleanInputData } from '../common/Utility';


export class CaseDataFileUploadPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      formName: this.props.formName,
      fileForm: this.props.fileForm,
      fileUploadAgreement: false,
      formIsValid: false,
      fileContents: null,
      fileName: '',
      uploadFailed: true,
      error: null,
      downloadUrl: null,
    };

    this.handleClick = this.handleClick.bind(this);
    this.submit = this.submit.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
    this.onLoad = this.onLoad.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
    this.checkFileExtension = this.checkFileExtension.bind(this);
  }
  onCancel(event) {
    event.preventDefault();
    browserHistory.push(pathConstants.pathToHome);
  }
  submit(event) {
    event.preventDefault();

    this.props.actions.uploadFile(this.state.fileContents, this.state.fileName)
      .then(response => {
        if(response){
          // Check if file upload has failed. This is not returned
          // for all scenarios and for success scenarios, hence
          // checking for existence of field as well.
          if ('upload_status' in response && response.upload_status == 'failed') {
            this.setState({
              error: FileUploadConstants.FILE_NOT_UPLOADED,
              uploadFailed: true,
              formIsValid: false
            }, function() {
              window.scrollTo(0,0);
            });
          }
          else {
            this.setState({
              uploadFailed: false,
              fileUploadAgreement: false,
              formIsValid: false
            });
          }
        } else {
          this.setState({error: FileUploadConstants.FILE_NOT_UPLOADED});
        }
        window.scrollTo(0,0);
      })
      .catch(error => {
        this.setState({uploadFailed: true});
        throw(error);
      });
     let fileInput = document.getElementById("file-upload");
     fileInput.value = "";
    return false;
  }

  handleClick() {


    let canUpload = this.state.fileUploadAgreement;
    if (canUpload === true) {
      canUpload = false;
    }
    else {
      canUpload = true;
    }
    if(this.state.fileContents && canUpload && !this.state.error) {
      this.setState({formIsValid:true});
    } else {
      this.setState({formIsValid: false});
    }
    this.setState({fileUploadAgreement: canUpload});
  }




  uploadFile(event) {

    event.preventDefault();
    let reader = new FileReader();
    let file = event.target.files[0];
    this.setState({fileName: file.name});
    const CSV = "csv";
    if(this.checkFileExtension(file.name) === CSV &&
      file.size < FileUploadConstants.MAX_FILE_SIZE){
      this.setState({error: null, uploadFailed: true});
      reader.onload = this.onLoad;
      reader.readAsText(file);
    } else if(this.checkFileExtension(file.name)!==CSV){
      this.setState({
        error: FileUploadConstants.FILE_WRONG_FORMAT,
        uploadFailed: true,
        formIsValid: false
      }, function() {
        window.scrollTo(0,0);
      });
    } else if(file.size > FileUploadConstants.MAX_FILE_SIZE){
      this.setState({
        error: FileUploadConstants.FILE_TOO_LARGE,
        formIsValid: false
      }, function() {
        window.scrollTo(0,0);
      });

    }


  }

  onLoad(e) {

  const fileContents = e.target.result;
  const defaultPattern  = /[^\x00-\x7F]/g;
  const customPattern = window.customRegex || defaultPattern;

  // Check if the file can be encoded to base64
  try {
    if (customPattern.test(fileContents)) {
      console.log(fileContents.match(customPattern));
      throw new Error('non-alphanumeric detected.');
    } else {
      btoa(fileContents);
    }
  } catch (error) {
      // replace non-ASCII characters
      let cleanedFile = fileContents.replace(customPattern, '');
      // parse the csv content
      const rows = cleanedFile.split(/\r\n|\n|\r/).filter(row => row.trim() !== '');
      const headerColumns = rows[0].split(',');
      const columnCount = headerColumns.length;

      // make sure rows have expected num of columns
      const cleanedRows = rows.map(row => {
        const columns = row.split(',').map(column => column.trim());
        // If the number of columns is less than expected, fill with empty strings
        while (columns.length < columnCount) {
          columns.push('');
        }
        // If the number of columns is more than expected, truncate the excess columns
        return columns.slice(0, columnCount).join(',');
      });
      // Reconstruct the cleaned CSV content
      const cleanedCSV = cleanedRows.join('\n');

      // create new file without non-ASCII characters
      const cleanedBlob = new Blob([cleanedCSV], { type: 'text/csv' });
      const downloadUrl = URL.createObjectURL((cleanedBlob));

      this.setState({
        error: FileUploadConstants.FILE_NOT_ENCODABLE,
        uploadFailed: true,
        formIsValid: false,
        fileContents: null,
        downloadUrl: downloadUrl
      }, () => {
        window.scrollTo(0, 0);
      });

    return;
  }

  this.setState({ fileContents });

  if (this.state.fileUploadAgreement) {
    this.setState({ formIsValid: true });
  }


    //**** Implementing Validations by Manuel Trujillo
    //*
    //*************************************************
    try{
        var myVar = 0;
        var index;
        var itemindex;
        var myChar;
        var myRows = -1;
        var strHeaderTot = '';
         if (myVar != 1){

            //validating number of headers in CSV
            var delimiter = ',';
            var escape = '\n';
            var rows = fileContents.split(escape);
            for (index in rows)
            {
                  myRows++;
                  myChar = '';
                  itemindex= -1;

                  // Total number of elemnts in header should be 24
                  if (myRows == 0 )
                  {
                      var items = rows[index].split(delimiter);
                      for (itemindex in items)
                      {
                          myChar = myChar + items[itemindex] +';';
                          myVar++;

                      }
                     if (myVar != 24 && strHeaderTot == '')
                     {
                      strHeaderTot = 'Error: Uploaded file contains an incorrect number of header columns. File should contain 24 header columns, file uploaded has ' + myVar + '.';
                         this.setState(
                                       {
                                          error: strHeaderTot,
                                          uploadFailed: true,
                                          formIsValid: false
                                       }, function() {
                                                        window.scrollTo(0,0);
                                                      }
                                      );
                                      setTimeout(() => {  location.reload();}, 30000);
                     }



                  }
                  // Additional validation might be needed here.
                  //-----------------------------------------------

            }
           //==============================



         }

     }catch(error){
         this.setState({
           error: 'Error in CSV validations',
           uploadFailed: true,
           formIsValid: false,
           fileContents: null
       } ,function() {
           window.scrollTo(0,0);
         });
         setTimeout(() => {  location.reload();}, 10000);
     }

    //***************************************************



  }

  scrollToTop(){
    window.scrollTo(0,0);
  }

  checkFileExtension(filename) {
    const fileParts = filename.split('.');
    return fileParts[fileParts.length -1];
  }





  render() {
    return (
      <CaseDataFileUploadForm
        form={this.props.fileForm}
        onSubmit={this.submit}
        onClick={this.handleClick}
        onCancel={this.onCancel}
        uploadFile={this.uploadFile}
        formIsValid={this.state.formIsValid}
        error={this.state.error}
        uploadFailed={this.state.uploadFailed}
        fileUploadAgreement={this.state.fileUploadAgreement}
        downloadUrl={this.state.downloadUrl}/>
    );
  }
}

CaseDataFileUploadPage.propTypes = {
  actions: PropTypes.object.isRequired,
  fileForm: PropTypes.object.isRequired,
  formName: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired
};


function mapStateToProps(state) {
  let fileForm = {},
    formName = FormName.itaFileUpload;

  if (state.forms.length > 0) {
    fileForm =
      searchForFormById(state.forms, FormName.itaFileUploadId);
  }
  return {
    fileForm: fileForm,
    formName: formName,
    user: state.user[state.user.length - 1] || {}
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(caseDataFileUploadActions, dispatch)
  };
}


export default connect(mapStateToProps, mapDispatchToProps)(CaseDataFileUploadPage);



/** WEBPACK FOOTER **
 ** ./src/components/fileUpload/CaseDataFileUploadPage.js
 **/